
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import loadable from "@loadable/component";
const Lottie = loadable(() => import("react-lottie"), {ssr: false});
import styles from "./styles.css";
import { NUMBER } from "../../../constants/app-constants";
import Modal from "../../shared/modal";
import Loader from "./lottie-files/loader.json";
const DEFAULT_LOTTIE_OPTIONS = {
    loop: true,
    autoplay: true,
    animationData: Loader,
    rendererSettings: { preserveAspectRatio: "xMidYMid slice" }
};
const EkycLoader = ({
    title,
    isVerifying = true
}) => {
    const [time, setTime] = useState(NUMBER.ZERO);
    useEffect(() => {
        const timer = window.setInterval(() => {
            setTime((prevTime) => {
                if (prevTime === NUMBER.TEN) {
                    window.clearInterval(timer);
                    return 0;
                } else return prevTime + NUMBER.ONE;
            });
        }, NUMBER.THOUSAND);
    }, []);
    const getWidth = () => {
        return `${time * NUMBER.TEN}%`;
    };
    return (
        <Modal isOpen={true}>
            <div styleName={"styles.verifyCardWrapper"}>
                <Lottie options={DEFAULT_LOTTIE_OPTIONS} height={"48px"} width={"48px"} />
                <div styleName={"styles.titleText"}>
                    <h3>We are {isVerifying ?  "verifying" : "uploading"} your</h3>
                    <h3>{title}</h3>
                </div>
                <p>It may take up to 10 seconds</p>
                <div styleName={"styles.timers"}  >
                    <div styleName={"styles.progressLoader"} style={{width: `${getWidth()}`}} />
                </div>
            </div>
        </Modal>
    );
};
EkycLoader.propTypes = {
    title: PropTypes.string,
    isVerifying: PropTypes.bool
};
export default EkycLoader;
